export default class FormatValue {
  /**
   * @param {*} type
   * @param {*} digits
   * @param {*} mask
   */
  constructor({ type, digits, mask }) {
    this.type = type;
    this.digits = digits;
    this.mask = mask;
  }

  /**
   * Создать объект FormatValue из объекта произвольного типа.
   * @param {unknown} obj
   * @return {FormatValue | undefined}
   */
  static fromJSON(obj) {
    if (!obj) return undefined;
    if (typeof obj !== 'object') throw new Error('not an object');
    return new FormatValue(obj);
  }
}
